import { get, find } from 'lodash';
import { createSelector } from 'reselect';
import {
  makeSelectIsDistributionLink,
  makeSelectIsPeeq,
} from 'containers/Survey/shared-selectors';

export const getSelectedAccount = (user) => {
  const accounts = get(user, 'userDetails.accounts', []);
  return find(accounts, 'selected');
};

const selectUserDomain = (state) => get(state, 'user');

const makeSelectAccountPerks = createSelector(
  selectUserDomain,
  makeSelectIsDistributionLink,
  makeSelectIsPeeq,
  (user, isDistributionLink, isPeeq) => {
    if (get(user, 'userDetails.isProdegeUser', false) && isDistributionLink) {
      return get(user, 'userDetails.perkMetadata.forDistributionLink', {});
    }
    if (isPeeq) {
      return get(user, 'userDetails.perkMetadata.forPeeq', {});
    }
    return get(user, 'userDetails.perkMetadata', {});
  },
);

const makeSelectIsPollfishAdmin = createSelector(selectUserDomain, (user) =>
  get(user, 'userDetails.isAdmin', false),
);

export { selectUserDomain, makeSelectAccountPerks, makeSelectIsPollfishAdmin };
